/* eslint-disable react-hooks/exhaustive-deps */
import { useOrgHelper } from "@propelauth/react";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useWorkspaceStore from "../store/workspace/workspaceStore";
import { useCurrentWorkspace } from "./QueryHooks";

const useSelectWorkspace = () => {
  const { setWorkspace, workspace } = useWorkspaceStore();
  const uid = useParams();
  const orgs = useOrgHelper().orgHelper?.getOrgs();
  const selectedWorkspace: any = useMemo(
    () =>
      orgs?.find(
        (item: any) => item?.orgMetadata?.unique_identifier === uid?.workspaceId
      ) || undefined,
    [orgs?.length, uid?.workspaceId]
  );

  const navigate = useNavigate();
  useEffect(() => {
    // Only redirect if we have orgs AND we're on a workspace-specific route AND workspace not found
    // This prevents race condition with RootPage polling logic
    if (orgs && orgs.length && !selectedWorkspace && uid?.workspaceId) {
      // Add a small delay to allow RootPage polling logic to complete
      const timeoutId = setTimeout(() => {
        // Double-check that workspace still doesn't exist after delay
        const currentOrgs = orgs;
        const currentWorkspace = currentOrgs?.find(
          (item: any) => item?.orgMetadata?.unique_identifier === uid?.workspaceId
        );
        if (!currentWorkspace) {
          navigate("/workspace-not-found", { replace: true });
        }
      }, 3000); // 3 second delay to allow workspace creation polling
      
      return () => clearTimeout(timeoutId);
    }
    
    return undefined; // Explicit return for ESLint
  }, [orgs?.length, selectedWorkspace, uid?.workspaceId, navigate]);

  const workspaceData: any = useCurrentWorkspace({
    workspaceId: selectedWorkspace?.orgId,
    enabled: !!selectedWorkspace?.orgId,
  });

  useEffect(() => {
    if (workspaceData?.isSuccess) {
      localStorage.setItem("he_defws", workspaceData?.data?.id);
      setWorkspace(workspaceData.data);
    }
  }, [workspaceData?.isSuccess, workspaceData?.data?.id]); // Add workspaceData as a dependency

  useEffect(() => {
    if (workspaceData?.isSuccess) return;
    if (!uid?.workspaceId) return;

    const orgName = selectedWorkspace?.orgName ?? selectedWorkspace?.name;
    if (!orgName) return;

    if (workspace?.workspace_name) return;

    setWorkspace({
      ...(workspace ?? {}),
      unique_identifier: uid.workspaceId,
      workspace_name: orgName,
    });
  }, [selectedWorkspace, uid?.workspaceId, workspaceData?.isSuccess, workspace, setWorkspace]);

  return workspaceData;
};

export default useSelectWorkspace;
